/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpUtil from 'mbp-api-util';
import restClient from '../cart-service-apis/restClient';

/**
 * getSearchQAS
 *
 * docs - https://docs.experianaperture.io/address-validation/experian-address-validation/address-api-reference/api-specification/
 * url - https://api.experianaperture.io/address/search/v1
 *
 * @param {Object} args
 * @param {Object} args.payload
 * @param {String} args.payload.country_iso
 * @param {Array}  args.payload.datasets
 * @param {Object} args.payload.components
 * @param {String} args.payload.components.unspecified
 * @param {Number} args.payload.max_suggestions
 *
 * Example:
 *  payload = {
      country_iso: 'USA',
      datasets: ['us-address'],
      max_suggestions: 2,
      components: {
          unspecified: ['Miami'],
      },
    }
  */

const getSearchQAS = (payload) => {
    const envObj = {
        protocol: 'https',
        host: mbpUtil.getEnv('APP_VERIFY_ADDRESS_HOST_V2') || 'api.experianaperture.io',
        rootUri: 'address',
        prefix: '/',
    };

    const resourcePage = '/search/v1';

    const headers = {
        'Auth-Token': mbpUtil.getEnv('APP_VERIFY_ADDRESS_AUTH_TOKEN') || '',
    };
    const params = { };

    return restClient.postRequest(envObj, resourcePage, 'InitialHeaders', payload, params, headers, false)
        .then((response) => response);
};

export default getSearchQAS;
